import { instance } from './setupAxios';

// 드림콘서트 드림루키 랜딩페이지 조회수 카운트
export const getRookie = () => {
	return instance.get('/public/rookie');
};
